/* eslint-disable @next/next/no-img-element */
// libraries
import React, { useState } from 'react';
import { BsEye } from 'react-icons/bs';
// utils
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { IoMdBusiness } from "react-icons/io";
import { NumeroFormatado, arrumaData, removerAcentos, toPrice } from '../../../utils/FunctionsGlobals';
import { useAuth } from '../../context/Info';
import styles from './CardApartament.module.css';
const CardApartament: React.FC<{
    slide: any;
    i: number;
    stylesCard?: any;
    site: any;
    allViewProperties: Array<any>;
    favorito: any;
    codsite?: any;
    activeCachePage?: () => void;
}> = ({ slide, i, stylesCard, site, allViewProperties, activeCachePage, favorito, codsite }) => {
    // constants
    const {
        delete_favorito,
        include_favorito
    } = useAuth();
    const validationSaleDiscount =
        slide?.venda > 0
            ? slide?.preco_especial?.preco_especial_venda > 0
            : null;
    const validationRentDiscount =
        slide?.aluguel > 0
            ? slide?.preco_especial?.preco_especial_locacao > 0
            : null;
    const discountSaleActual =
        slide?.venda > 0 ? slide?.preco_especial?.preco_especial_venda : null;
    const discountRentActual =
        slide?.aluguel > 0
            ? slide?.preco_especial?.preco_especial_locacao
            : null;

    // useState
    const [newIdCard, setNewIdCard] = useState<any>([]);
    const [active, setActive] = useState(false);
    const valoresPermitidos = ['mobiliado','lançamento','planta'];
    const [isHovered, setIsHovered] = useState(false);
    var cor_fundo = site?.cor8;
    var cor_letra = site?.cor9;

    const renderPath = () => {
        const validationModelSale = slide?.venda ? 'venda' : '';
        const validationModelRent = slide?.aluguel ? 'aluguel' : '';
        const validationModel =
            validationModelSale || validationModelRent || 'venda';
        const newPath = `/imoveis/${validationModel}/${
            slide?.cidade?.nome ? slide?.cidade?.nome.replaceAll('-', '002D').replaceAll('/', '-').replaceAll('?', '-') : '-'
        }/${slide?.bairro?.nome ? slide?.bairro?.nome.replaceAll('/', '-').replaceAll('?', '-') : '-'}/${site?.exibir_empreendimento ? slide?.empreendimento?.nome?.replaceAll("\n", '-') || '-' : '-'}/${
            slide?.tipo?.nome
                ? slide?.tipo?.nome.replaceAll('-', '002D').replaceAll('/', '_')
                : '-'
        }/${
            slide?.referencia
                ? slide?.referencia.replaceAll('-', '002D').replaceAll('/', '_')
                : '-'
        }/imovel/${slide?.id}${codsite ? '?codsite='+codsite : ''}`.replaceAll(' ', '-');
        return removerAcentos(newPath).toLowerCase();
    };

    const formatDate = (timestamp: string | number): string => {
        const date = new Date(Number(timestamp)); // Converte para objeto Date
        const currentDate = new Date(); // Data atual

        if (date > currentDate) {
          const monthNames = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ];

          const month = monthNames[date.getMonth()]; // Nome do mês (0-11)
          const year = date.getFullYear(); // Ano completo

          return `Entrega em ${month} de ${year}`; // Formato: "Mês de Ano"
        }

        return ""; // Para datas no passado
    }

    const GetPhoto = slide?.fotos?.url_foto ? slide?.fotos : slide?.fotos?.length > 0 ? slide?.fotos?.find((v: any) => v.destaque === true) : "";

    return (
        <>
            <div
                className={stylesCard || styles.card}
                onClick={activeCachePage ? activeCachePage : () => null}
                style={{
                    backgroundColor: isHovered ? cor_fundo || "#ffffff" : "#ffffff", // Cor de fundo no hover ou normal
                    color: isHovered ? cor_letra || "#1a1a1a" : "#1a1a1a", // Cor de fundo no hover ou normal
                }}
                onMouseEnter={() => setIsHovered(true)}  // Ativa hover
                onMouseLeave={() => setIsHovered(false)} // Desativa hover
            >
                <div
                    key={i}
                    onMouseEnter={() => {
                        setNewIdCard([...newIdCard, slide?.id]);
                        setActive(true);
                    }}
                    onMouseLeave={() => {
                        if (newIdCard.includes(slide?.id)) {
                            const newCards = newIdCard.filter(
                                (v: any) => v !== slide?.id
                            );
                            setNewIdCard(newCards);
                            setActive(false);
                        }
                    }}
                >
                    <div
                        className={
                            stylesCard
                                ? styles.photo_empty_mini
                                : styles.photo_empty
                        }
                    >
                        { favorito.indexOf(slide?.id) >= 0 ?
                            <div className={styles.adjust_favorito}>
                                <div
                                    className={styles.favorito}
                                >
                                    <FaHeart size={25} color="red" onClick={() => delete_favorito(slide?.id)} className={styles.favorito_icon}/>
                                </div>
                            </div>
                        :
                            <div className={styles.adjust_favorito}>
                                <div
                                    className={styles.favorito}
                                >
                                    <FaRegHeart size={25} onClick={() => include_favorito(slide?.id)} color="#ffffff" className={styles.favorito_icon}/>
                                </div>
                            </div>
                        }
                        <a href={renderPath()} title={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`} style={{cursor: 'pointer'}} {...site?.id == "2015" ? {target:"_blank"} : ""}>

                                {GetPhoto?.url_foto ?
                                    <img
                                        src={GetPhoto?.url_foto.replaceAll("_g","_m")}
                                        title={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                        alt={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                        className={
                                            stylesCard
                                            ? styles.photo_position_mini
                                            : styles.photo_position
                                        }
                                    />
                                : <img
                                    src={'https://fotos.sobressai.com.br/Fotos/imovel_sem_foto.jpg'}
                                    alt={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                    title={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                    className={
                                        stylesCard
                                        ? styles.photo_position_mini
                                        : styles.photo_position
                                    }
                                />}
                                {slide?.origem == "Orulo" && site?.id == 2196 ?
                                    <div className={styles.comVideo2196}>
                                        <div>ESTUDA DAÇÃO</div>
                                    </div>
                                : null}
                                {slide?.categoria?.id == 9999 || slide.exclu == 1 ?
                                <div
                                    className={styles.comVideo} style={site?.id == 1630 ? {background: "#65ff00", color:"#000000"} : site?.id == 2331 ? {background: "#2B394E"} : site?.id == 2348 ? {background: "##5d2224"} : site?.id == 2114 ? {background: "#191f2f"} : site?.id == 2195 ? {background: "#0000FF"} : site?.id == "2014" || site?.id == "1884" ? {background: "#000000"} : {background: "#5d2224"}}
                                >
                                    <div>Exclusivo</div>
                                </div>
                                :
                                    site?.mostrar_data_entrega && formatDate(slide?.data_entrega) != "" ?
                                        <div
                                            className={styles.comVideo} style={site?.id == 1630 ? {background: "#65ff00", color:"#000000"} : site?.id == 2331 ? {background: "#2B394E"} : site?.id == 2348 ? {background: "#5d2224"} : site?.id == 2114 ? {background: "#191f2f"} : site?.id == 2212 ? {background: "#FFFFFF",color: "#000000",fontSize: 13} : site?.id == 2177 ? {background: "#50c878",fontSize: 13} : site?.id == "2014" ? {background: "#000000",fontSize: 13} : {background: "#1A1A1A",fontSize: 13}}
                                        >
                                            <div>{formatDate(slide?.data_entrega)}</div>
                                        </div>
                                    :
                                    slide?.categoria?.nome && valoresPermitidos.some(valor => slide?.categoria?.nome.toLowerCase().includes(valor) && !slide?.categoria?.nome.toLowerCase().includes("semi")) ?
                                        <div
                                            className={styles.comVideo} style={site?.id == 1630 ? {background: "#65ff00", color:"#000000"} : site?.id == 2331 ? {background: "#2B394E"} : site?.id == 2348 ? {background: "#5d2224"} : site?.id == 2231 ? {background: "#000000"} : site?.id == 2114 ? {background: "#191f2f"} : site?.id == 2195 ? {background: "#0000FF"} : site?.id == 2126 ? {background: "#ab0303"} : site?.id == 2177 ? {background: "#50c878"} : site?.id == "2014" || site?.id == "1884" ? {background: "#000000"} : {background: "#5d2224"}}
                                        >
                                            <div>{slide?.categoria?.nome.toLowerCase().includes('lançamento') ? 'Lançamento' : slide?.categoria?.nome.toLowerCase().includes('mobiliado') ? 'Mobiliado' : 'Na Planta'}</div>
                                        </div>
                                        :
                                        slide?.mini_banner_texto ?
                                            <div
                                                className={styles.comVideo} style={site?.id == 1630 ? {background: "#65ff00", color:"#000000"} : site?.id == 2331 ? {background: "#2B394E"} : site?.id == 2348 ? {background: "#5d2224"} : site?.id == 2231 ? {background: "#000000"} : site?.id == 2114 ? {background: "#191f2f"} : site?.id == 2195 ? {background: "#0000FF"} : site?.id == 2177 ? {background: "#50c878"} : site?.id == "2014" || site?.id == "1884" ? {background: "#000000"} : {background: "#ba1319"}}
                                            >
                                                <div>{slide?.mini_banner_texto}</div>
                                            </div>
                                            :
                                            slide?.link_video && ((slide?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && slide?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ?
                                                <div
                                                    className={styles.comVideo} style={site?.id == 1630 ? {background: "#000000"} : site?.id == 2114 ? {background: "#191f2f"} : site?.id == 2331 ? {background: "#dec99e"} : site?.id == 2348 ? {background: "#5d2224"} : site?.id == 2212 ? {background: "#FFFFFF",color: "#000000"} : site?.id == 2177 ? {background: "#50c878"} : site?.id == "2014" ? {background: "#000000"} : {background: "#ba1319"}}
                                                >
                                                    <div>Imóvel com Vídeo</div>
                                                </div>
                                            : null
                                }
                                { site?.id != "1946" && site?.id != "1918" && site?.id != "1968" && site?.id != "2003" ?
                                    <div
                                        className={styles.codigoImovel}
                                        style={{
                                            background: `${site?.cor2 || 'green'}`,
                                            color: site?.id == "2126" ? "white" : site?.cor4 == site?.cor2 ? "white" : site?.cor4,
                                        }}
                                    >
                                        <div>{`Código: ${slide?.referencia}`}</div>
                                    </div>
                                : null }
                                {allViewProperties?.includes(slide?.id) ? (
                                    <div className={styles.container_view}>
                                        <BsEye
                                            size={14}
                                            color="white"
                                            style={{ marginRight: 5, marginTop: 2 }}
                                        />
                                        <div>Visualizado</div>
                                    </div>
                                ) : null}

                                {active ? (
                                    <>
                                        {newIdCard.includes(slide?.id) ? (
                                            <div
                                                className={
                                                    styles.active_indicator_top_open
                                                }
                                                style={{
                                                    backgroundColor:  cor_fundo || "rgb(0, 0, 0, 0.5)" // Cor de fundo no hover ou normal
                                                }}
                                            />
                                        ) : (
                                            <div
                                                className={
                                                    styles.active_indicator_top_close
                                                }
                                            />
                                        )}
                                        {newIdCard.includes(slide?.id) ? (
                                            <div
                                                className={
                                                    styles.active_indicator_bottom_open
                                                }
                                                style={{
                                                    backgroundColor:  cor_fundo || "rgb(0, 0, 0, 0.5)" // Cor de fundo no hover ou normal
                                                }}
                                            />
                                        ) : (
                                            <div
                                                className={
                                                    styles.active_indicator_bottom_close
                                                }
                                            />
                                        )}
                                    </>
                                ) : null}
                            </a>
                    </div>
                    {validationSaleDiscount || validationRentDiscount ? (
                        <div className={styles.discount} style={site?.id == 1630 ? { background: "#c49448" } : site?.id == 2348 ? {background: "#5d2224"} : site?.id == 2212 ? {background: "#FFFFFF",color: "#000000"} :  site?.id === "1934" ? { background: "#ec6730" } : {}}>
                            {site?.id == 604 || site?.id == 2098 ? "VALOR ESPECIAL" : site?.id == "874" ? "Oportunidade" : site?.id == "1654" ? "REDUZIU VALOR" : "Imóvel com Desconto"}
                        </div>
                    ) : null}
                    <a href={renderPath()} title={`${slide?.tipo?.nome} ${slide?.venda ? 'à venda' : 'para alugar'} no bairro ${slide?.bairro?.nome}, ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`} style={{cursor: 'pointer'}} {...site?.id == "2015" ? {target:"_blank"} : ""}>
                        <div className={styles.container_info}>
                            <div className={styles.container_info_header}>
                                <div className={styles.adjust_icon}>
                                    <div className={styles.txt} style={site?.id == '2103' ? {textAlign: 'left'} : {}}>
                                        {site?.id == 2272 ? slide?.titulo ? <b>{slide?.titulo.toUpperCase()}</b> : slide?.tipo?.nome.toUpperCase() : slide?.tipo?.nome}
                                    </div>
                                </div>

                                {slide?.empreendimento?.nome && site?.exibir_empreendimento && site?.id != 2272 && site?.id != 2258 ? (
                                    <div className={styles.adjust_icons}>
                                        <div className={styles.margin} style={site?.id == '2103' ? {textAlign: 'left'} : {}}>
                                            <div className={styles.svg}>
                                                <IoMdBusiness size={17}/>
                                            </div>
                                            {slide?.empreendimento?.nome}
                                        </div>
                                    </div>
                                ) : null}

                                <div className={styles.adjust_address} style={site?.id == '2103' ? {alignSelf: 'normal'} : {}}>
                                    <svg
                                        viewBox="0 -10 100 100"
                                        height="16px"
                                        width="16px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                    </svg>
                                    <div className={styles.address} style={site?.id == '2103' ? {textAlign: 'left'} : {}}>
                                        {slide?.cidade?.nome || slide?.bairro?.nome
                                            ? `${slide?.cidade?.nome || ''}${
                                                slide?.bairro?.nome
                                                    ? ` / ${slide?.bairro?.nome}`
                                                    : ''
                                            }`
                                            : 'Sem dados de endereço'}
                                    </div>
                                </div>
                                <ul className={styles.adjust} style={site?.id == '2103' ? {margin: '2px 0px'} : {}}>
                                    {slide?.dormitorios || slide?.suites ? (
                                        <li className={styles.adjust_icons} key={"quartos"} title="Quantidade de Dormitórios">
                                            <svg
                                                viewBox="0 0 640 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {slide?.dormitorios > 0 ? slide?.dormitorios == 1 ? "1 Quarto" : slide?.dormitorios+" Quartos" : slide?.suites == 1 ? " 1 Suíte" : " "+slide?.suites+" Suítes"}
                                                {slide?.suites > 0 && slide?.dormitorios > 0 ? slide?.suites == 1 ? " (1 Suíte)" : " ("+slide?.suites+" Suítes)" : null}
                                            </div>
                                        </li>
                                    ) : slide?.qtd_salas > 0 ? (
                                        <li className={styles.adjust_icons} key={"salas"} title="Quantidade de Salas">
                                                {slide?.qtd_salas == 1 ? "1 Sala" : slide?.qtd_salas+" Salas"}
                                        </li>
                                    ) : null}

                                    {/* {slide?.suites > 0 && (
                                        <li className={styles.adjust_icons} title="Quantidade de Dormitórios">
                                            <svg
                                                viewBox="0 0 640 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {slide?.suites == 1 ? "1 Suíte" : slide?.suites+" Suítes"}
                                            </div>
                                        </li>
                                    )} */}

                                    {slide?.garagems ? (
                                        <li className={styles.adjust_icons} key={"vagas"} title="Quantidade de vagas">
                                            <svg
                                                viewBox="0 20 512 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {slide?.garagems == 1 ? "1 Vaga" : slide?.garagems+" Vagas"}
                                            </div>
                                        </li>
                                    ) : null}
                                    { slide?.banheiros ?
                                        <li className={styles.adjust_icons} key={"banheiros"} title="Quantidade de Banheiros">
                                            <svg
                                                viewBox="0 20 512 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M32 384a95.4 95.4 0 0 0 32 71.09V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h256v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-40.91A95.4 95.4 0 0 0 480 384v-48H32zm464-128H80V69.25a21.26 21.26 0 0 1 36.28-15l19.27 19.26c-13.13 29.88-7.61 59.11 8.62 79.73l-.17.17a16 16 0 0 0 0 22.59l11.31 11.31a16 16 0 0 0 22.63 0L283.31 81.94a16 16 0 0 0 0-22.63L272 48a16 16 0 0 0-22.62 0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62l-19.26-19.27A69.25 69.25 0 0 0 32 69.25V256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {slide?.banheiros == 1 ? "1 Banheiro" : slide?.banheiros+" Banheiros"}
                                            </div>
                                        </li>
                                    : null }
                                    {slide?.area_privativa > 0  && (site?.id == "1767" || site?.id == "2118" || (site?.id == 2135 && slide?.tipo?.nome == "Apartamento")) ? (
                                        <li className={styles.adjust_icons} key={"privativa"} title="Área Privativa">
                                            <svg
                                                viewBox="0 20 512 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {NumeroFormatado(Number(slide?.area_privativa)) + " m² privativos"}
                                            </div>
                                        </li>
                                    ) : (
                                    slide?.area_total > 0 ? (
                                        <li className={styles.adjust_icons} key={"total"} title="Área Total">
                                            <svg
                                                viewBox="0 20 512 512"
                                                height="12px"
                                                width="12px"
                                                aria-hidden="true"
                                                focusable="false"
                                                fill="currentColor"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                                ></path>
                                            </svg>
                                            <div className={styles.margin}>
                                                {NumeroFormatado(Number(slide?.area_total)) + " " + (slide?.area_tipo || 'm²')}
                                            </div>
                                        </li>
                                    ) : (
                                        slide?.terreno > 0 ? (
                                            <li className={styles.adjust_icons} key={"terreno"} title="Área do Terreno">
                                                <svg
                                                    viewBox="0 20 512 512"
                                                    height="12px"
                                                    width="12px"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    fill="currentColor"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                                    ></path>
                                                </svg>
                                                <div className={styles.margin}>
                                                    {NumeroFormatado(Number(slide?.terreno)) + " " + (slide?.area_tipo || 'm²')}
                                                </div>
                                            </li>
                                        ) : slide?.area_privativa > 0 && (
                                            <li className={styles.adjust_icons} key={"priva"} title="Área Privativa">
                                                <svg
                                                    viewBox="0 20 512 512"
                                                    height="12px"
                                                    width="12px"
                                                    aria-hidden="true"

                                                    focusable="false"
                                                    fill="currentColor"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                                    ></path>
                                                </svg>
                                                <div className={styles.margin}>
                                                    {NumeroFormatado(Number(slide?.area_privativa)) + " m² privativos"}
                                                </div>
                                            </li>
                                      )
                                    ))}
                                </ul>
                            </div>
                            {
                                slide?.d1 > 0 && slide?.temporada
                            ? (
                                <div
                                    className={ styles.adjust_price } style={site?.id == '2103' ? {justifyContent: 'left'} : {}}
                                >
                                    <p className={ styles.price } >
                                        {site?.id != '1667' ?
                                            <>
                                            Diária:
                                                {` ${site?.moeda_tipo} ${toPrice(
                                                    slide?.d1,
                                                    2
                                                )}`}
                                            </>
                                        : <>Diária: Sob Consulta</>}
                                    </p>
                                </div>
                            ) : null}
                            {Number(
                                slide?.exibir_preco_locacao &&
                                    slide?.preco_locacao > 0 && site?.id != 1801
                            ) ? (
                                <div
                                    className={
                                        validationRentDiscount
                                            ? styles.adjust_icon
                                            : styles.adjust_price
                                    }
                                    style={site?.id == '2103' ? {justifyContent: 'left'} : {}}
                                >
                                    <p
                                        className={
                                            validationRentDiscount
                                                ? styles.text_decoration
                                                : styles.price
                                        }
                                    >
                                        Aluguel:
                                        {validationRentDiscount
                                            ? ` De: ${site?.moeda_tipo} ${toPrice(
                                                slide?.preco_locacao,
                                                2
                                            )}`
                                            : ` ${site?.moeda_tipo} ${toPrice(
                                                slide?.preco_locacao,
                                                2
                                            )}`}
                                    </p>
                                    {validationRentDiscount ? (
                                        <div className={styles.price}>
                                            {`Por: ${site?.moeda_tipo} ${toPrice(
                                                discountRentActual,
                                                2
                                            )}`}
                                        </div>
                                    ) : null}
                                </div>
                            ) : (slide?.aluguel == 1 && site?.id != 1801) ? (
                                <div className={styles.adjust_price} style={site?.id == '2103' ? {justifyContent: 'left'} : {}}>
                                    <p className={styles.price}>
                                        Aluguel: Sob Consulta
                                    </p>
                                </div>
                            ) : null}
                            {Number(
                                slide?.exibir_preco_venda && slide?.preco_venda > 0
                            ) ? (
                                validationSaleDiscount ?
                                    <div className={styles.adjust_icon}>
                                        <div className={styles.line}>
                                            <p className={styles.text_decoration_limpo}>Venda de:</p>
                                            <p className={styles.text_decoration}>
                                                {` ${site?.moeda_tipo} ${toPrice(
                                                        slide?.preco_venda,
                                                        2
                                                    )}`}
                                            </p>
                                        </div>
                                        <div className={styles.price}>
                                            {`Por: ${site?.moeda_tipo} ${toPrice(
                                                discountSaleActual,
                                                2
                                            )}`}
                                        </div>
                                    </div>
                                :   <div
                                        className={styles.adjust_price} style={site?.id == '2103' ? {justifyContent: 'left'} : {}}
                                    >
                                        <p
                                            className={styles.price}
                                            style={site?.id == 2126 ? {fontSize: 18} : {}}
                                        >
                                            Venda:
                                            {` ${site?.moeda_tipo} ${toPrice(
                                                    slide?.preco_venda,
                                                    2
                                                )}`}
                                        </p>
                                    </div>

                            ) : (slide?.venda == 1) ? (
                                <div className={styles.adjust_price} style={site?.id == '2103' ? {justifyContent: 'left'} : {}}>
                                    <p className={styles.price}>
                                        Venda: Sob Consulta
                                    </p>
                                </div>
                            ) : null}
                            {site?.id == "1892" && slide?.data_edicao ?
                                <div className={styles.data_edicao}>Data última edição: {arrumaData(slide?.data_edicao)}</div>
                            : null}
                        </div>
                        </a>
                </div>
            </div>
        </>
    );
};

export default CardApartament;
